const ufeApi = require('services/api/ufeApi');
// https://confluence.sephora.com/wiki/display/ILLUMINATE/Update+preferred+zip+code

function updatePreferredZipCode(args) {
    const url = '/api/users/profile/preferredZipCode';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(args)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = updatePreferredZipCode;
